import { Collapse } from 'bootstrap';
import { loadingOverlay, scrollToElement } from "./utils";

$(document).ready(function(){
    var contentId = '#resource-hub-content';
    var $content = $(contentId);
    if(!$content.length) {
        return;
    }
    
    var selectors = {
        lessonFilter: '#lesson-filter',
        gradeFilter: '#grade-filter',
        resourceTypeFilter: '#resource-type-filter',
        activeFilters: '#resource-hub-content .active-filters',
        pagination: '#resource-hub-content .page-numbers',
        filtersWrapper: '#resource-hub-content .resource-filters-wrapper',
        filters: '#resource-hub-content .resource-filters',
        filtersModal: '#resource-filter-modal',
        resetFilters: '#resource-hub-content .reset-filters'
    };
    
    var state_type = 'resource_hub';
    var errorMessage = $content.find('.ajax-error').get(0).outerHTML;
    
    bindEvents();
    initHistoryState();
    
    $(window).on('popstate', popStateHandler);
    
    function isLoading() {
        return $content.hasClass('loading');
    }
    
    function loadResources(url, pushState, stateParams) {
        
        toggleOverlay(true);
        
        // Set browser URL before AJAX request in case ajax does not work
        if(pushState) {
            stateParams.state_type = state_type;
            history.pushState(stateParams, "", url);
        }
        
        $.get(url, {
            [cmiscp_options.ajaxparam]: 1
        }).done(function(data){
            var $newContent = $(data).find(contentId).html();
            if($newContent.length){
                $content.html($newContent);
                bindEvents();
                if($(selectors.filtersModal).hasClass('show')){
                    showModalHandler();
                }
            }
            else {
                $content.html(errorMessage);
            }
            toggleOverlay(false);
            
        }).fail(function(){
            $content.html(errorMessage);
            toggleOverlay(false);
            
        });
    }
    
    function toggleOverlay(enable) {
        loadingOverlay($content, enable);
        loadingOverlay($(selectors.filtersModal).find('.modal-body'), enable);
    }
    
    /**
     * Bind click events to all links
     */
    function bindEvents() {
        
        $(selectors.lessonFilter)
                .find('a').off('click').on('click', lessonClickHandler);
        
        $(selectors.gradeFilter).add(selectors.pagination).add(selectors.activeFilters)
                .find('a').off('click').on('click', contentClickHandler);
        
        $(selectors.resetFilters).find('a').off('click').on('click', resetFiltersClickHandler);
        
        $(selectors.resourceTypeFilter).off('change').on('change', resourceFilterChangeHandler);
        
        $(selectors.filtersModal).off('show.bs.modal', showModalHandler).on('show.bs.modal', showModalHandler);
        $(selectors.filtersModal).off('hidden.bs.modal', hiddenModalHandler).on('hidden.bs.modal', hiddenModalHandler);
    }
    
    function lessonClickHandler(e) {
        
        if(!isLoading()){
            var $lessonFilter = $(selectors.lessonFilter);
            
            // Select new item and deselect all other
            $lessonFilter.find('a').removeClass('active');
            $(this).addClass('active');
            
            // Update the collapse label and close
            $('a[href="'+selectors.lessonFilter+'"]').text($(this).text());
            var collapse = Collapse.getInstance($lessonFilter.get(0));
            if(collapse){
                collapse.hide();
            }
            
            loadResources($(this).attr('href'), true, {
                lesson_id: $(this).attr('id')
            });
        }
        
        e.preventDefault();
        return false;
    }
    
    function contentClickHandler(e) {
        if(!isLoading()){
            loadResources($(this).attr('href'), true, {});
            e.preventDefault();
        }
        if($(this).parents(selectors.pagination).length){
            scrollToElement($content);
        }
        return false;
    }
    
    function resourceFilterChangeHandler(e) {
        if(!isLoading()){
            loadResources($(this).val(), true, {});
            e.preventDefault();
        }
        return false;
    }
    
    function resetFiltersClickHandler(e) {
        if(!isLoading()){
            $(selectors.lessonFilter).find('#nav-lesson-all').click();
        }
        e.preventDefault();
        return false;
    }
    
    function showModalHandler(e) {
        $(selectors.filtersModal).find('.modal-body').html($(selectors.filters).clone(true));
    }
    
    function hiddenModalHandler(e) {
        $(selectors.filtersModal).find('.modal-body').html('');
    }
    
    function initHistoryState() {
        var stateParams = {
            state_type: state_type
        };
        var $activeLesson = $(selectors.lessonFilter).find('a.active');
        if($activeLesson.length) {
            stateParams.lesson_id = $activeLesson.attr('id');
        }
        history.replaceState(stateParams, "", window.location.href);
    }
    
    function popStateHandler(e) {
        if(e.originalEvent && e.originalEvent.state) {
            var oState = e.originalEvent.state;
            if(oState.state_type && oState.state_type == state_type){
                if(oState.lesson_id){
                    $(selectors.lessonFilter).find('a').removeClass('active');
                    
                    var $currentItem = $(selectors.lessonFilter).find('#' + oState.lesson_id);
                    $currentItem.addClass('active');
                    $('a[href="'+selectors.lessonFilter+'"]').text($currentItem.text());
                }
                loadResources(window.location.href, false);
            }
        }
    }
    
});